import { useState } from 'react';
import { DataGrid } from '../../components/grid/DataGrid';
import { StoricoModifiche } from './StoricoModifiche';

const INTESTAZIONI: Record<string, string> = {
  Avvenuta: 'Quando',
  ChiaveRiga: 'Riga',
  NomeAutore: 'Chi',
  CampiCambiati: 'Campi',
  Campi: 'Cosa è cambiato',
};

/*  Le colonne, nell'ordine in cui si leggono. «Correlazione» sta in fondo perché non si
    legge: si cerca. È il codice che l'utente ha davanti quando segnala un errore, e senza
    la colonna in griglia il testo di questa schermata prometteva una ricerca che non si
    poteva fare.

    L'elenco lo rilegge anche `npm run contratti`, che confronta questi nomi con le colonne
    dichiarate dal backend: dentro le parentesi vanno solo nomi di colonna, i commenti
    stanno qui sopra.  */
const COLONNE = [
  'Avvenuta',
  'Tabella',
  'Operazione',
  'NomeAutore',
  'Campi',
  'CampiCambiati',
  'ChiaveRiga',
  'Correlazione',
];

/*  Il registro delle modifiche.

    Si arriva qui per due strade, e la schermata serve la seconda. La prima è partire da
    un documento — «cosa è successo a quest'ordine» — e per quella lo storico si apre
    dalla scheda del documento, dove la domanda nasce. La seconda è partire da una
    persona, da un giorno o da un errore segnalato: «cosa ha fatto Tal dei Tali martedì»,
    «cosa è cambiato nella richiesta con questo codice». È un elenco da filtrare, quindi
    è una griglia come tutte le altre.

    Aperta una riga si vede lo storico completo di quella riga di quella tabella, non solo
    la voce spuntata: chi cerca una modifica vuole quasi sempre vedere anche quelle
    intorno — cosa c'era prima, e cosa è successo dopo.
*/
export function ElencoRegistro() {
  const [aperta, setAperta] = useState<{ tabella: string; chiave: string } | null>(null);

  return (
    <section className="pagina con-scheda">
      <div className="colonna-principale">
        <header className="testata-pagina">
          <div>
            <h1>Registro modifiche</h1>
            <p>
              Ogni scrittura sul database, con i valori prima e dopo. Le voci le scrive
              l'applicativo dentro la stessa transazione della modifica che annotano:
              nessuno può aggiungerle, correggerle o cancellarle da qui, ed è la ragione
              per cui valgono qualcosa.
            </p>
            <p className="nota">
              Il codice nella colonna <strong>Correlazione</strong> è quello che l'API
              restituisce nell'intestazione <code>X-Correlazione</code> e che compare nei
              messaggi d'errore: cercandolo si vede tutto quello che ha cambiato un
              singolo clic.
            </p>
          </div>
        </header>

        <DataGrid
          nomeGriglia="registro"
          colonneVisibili={COLONNE}
          intestazioni={INTESTAZIONI}
          idSelezionato={null}
          onRigaSelezionata={(riga) => {
            const tabella = riga['Tabella'];
            const chiave = riga['ChiaveRiga'];
            if (typeof tabella === 'string' && typeof chiave === 'string')
              setAperta({ tabella, chiave });
          }}
        />
      </div>

      {aperta !== null && (
        <aside className="scheda">
          <header>
            <div>
              <h2>{aperta.tabella}</h2>
              <p className="dettaglio">{aperta.chiave}</p>
            </div>
            <button
              type="button"
              className="chiudi"
              onClick={() => setAperta(null)}
              aria-label="Chiudi"
            >
              ×
            </button>
          </header>

          <StoricoModifiche tabella={aperta.tabella} chiave={aperta.chiave} />
        </aside>
      )}
    </section>
  );
}
